<template>
	<div class="modal-backdrop" @click="close">
		<div class="ztl"></div>
		<div class="modal" @click.stop>
			<div class="modal-header"><span class="modalhr">设置</span></div>
			<div class="modal-body">
				<div class="modalnav">
					<div class="modalnavleft" ><router-link to="/">首页</router-link></div>
				
				</div></div>
			<div class="modal-body">
				<div class="modalnav">
					<div class="modalnavleft">字体：</div>
					<div class="modalnavright"><span v-on:click="heiti">手机默认</span>&nbsp;<span v-on:click="songti">宋体</span></div>
				</div>
				<div class="modalnav">
					<div class="modalnavleft">字号：</div>
					<div class="modalnavright"><span v-on:click="jianersz">-2</span>&nbsp;<span v-on:click="jianyisz">-1</span>&nbsp;<span v-on:click="morensz">默认</span>&nbsp;<span v-on:click="jiayisz">+1</span>&nbsp;<span v-on:click="jiaersz">+2</span></div>
				</div>
				<div class="modalnav">
					<div class="modalnavleft">背景：</div>
					<div class="modalnavright"><span v-on:click="baise">白色</span>&nbsp;<span v-on:click="huangse">黄色</span>&nbsp;<span v-on:click="lanse">蓝紫色</span></div>
				</div>
				<div class="modalnav">
					<div class="modalnavleft">夜间模式：</div>
					<div class="modalnavright"><span v-on:click="yejiank">开启</span>&nbsp;<span v-on:click="yejiang">关闭</span></div>
				</div>
			</div>
			<div class="modal-header"><span @click="close">关闭</span> </div>
		</div>

	</div>


</template>

<script>
	export default {
		name: 'modal',
		data() {
			return { themeName:'light'}
		},
		created(){
			this.themeName=localStorage.themeName;
		},
		methods: {
			close: function() {
				this.$emit('close');
			},
			morensz: function() {
				document.querySelector('#app').style.fontSize = '4.4vmin'
			},
			jiayisz: function() {
				document.querySelector('#app').style.fontSize = '4.9vmin'
			},
			jiaersz: function() {
				document.querySelector('#app').style.fontSize = '5.4vmin'
			},
			jianyisz: function() {
				document.querySelector('#app').style.fontSize = '3.9vmin'
			},
			jianersz: function() {
				document.querySelector('#app').style.fontSize = '3.4vmin'
			},
			songti: function() {
				document.querySelector('#app').style.fontFamily = 'simsun'
			},

			heiti: function() {
				document.querySelector('#app').style.fontFamily = ''
			},
			baise: function() {
				document.querySelector('#app').style.backgroundColor = '#FFFFFF'
			},
			huangse: function() {
				document.querySelector('#app').style.backgroundColor = '#c4b395'
			},
			lanse: function() {
				document.querySelector('#app').style.backgroundColor = '#CCCCFF'
			},
			yejiank: function() {
				this.themeName='dark';
				localStorage.themeName = this.themeName;
				location.reload();
			},
			yejiang: function() {
				this.themeName='light';
				localStorage.themeName = this.themeName;
				location.reload();
			}
		}
	}
</script>

<style>
	.modal-backdrop {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: rgba(0, 0, 0, .3);
		width: 100%;
		height: 100%;
	}

	.modal {
		background-color: #FFFFFF;
		color: #666;
		width: 100%;
	}
	.modalhl{
		width: 5vw;
		margin: 0;
		
	}
	.modalhr{
		flex: 1;
		justify-content: center;
		text-align: center;
		margin-left: -5vw;
		
	}

	.modal-header {
		margin: 0 6vw 0 6vw;
		height: 6.6vmax;
		border-bottom: #ebeaea 1px solid;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.modal-body {
		margin: 1vh 6vw 1vh 6vw;
		padding: 0;
	}

	.modalnav {
		display: flex;
		margin: 1vh 0 1vh 0;
		padding: 0;
	}
 
</style>
